import { action, makeObservable, observable, computed } from "mobx";
import { UploadFile } from "antd";
import TemplateManageStore from "./template_store";

type UploadImageType =
  | "templateParamFileName"
  | "socialCreditCertificateObjectNames"
  | "orderVoucherObjectNames"
  | "signAuthzCertificateObjectNames";
type UploadImageUrlType =
  | "templateParamFileNameUrl"
  | "socialCreditCertificateObjectNamesUrl"
  | "orderVoucherObjectNamesUrl"
  | "signAuthzCertificateObjectNamesUrl";

class UploadImgStore {
  templateManageStore: TemplateManageStore;
  name: UploadImageType;
  url: UploadImageUrlType;
  constructor(
    baseStore: TemplateManageStore,
    name: UploadImageType,
    url: UploadImageUrlType
  ) {
    this.templateManageStore = baseStore;
    this.name = name;
    this.url = url;
    makeObservable(this);
  }
  @observable _fileList: UploadFile[] = []; //上传营业执照图片文件
  @observable isEdited: boolean = false; //

  @computed get fileList(): UploadFile[] {
    // console.log(this._fileList);

    if (this.isEdited) {
      return this._fileList;
    } else {
      if (this.name === "templateParamFileName") {
        return this.templateManageStore['templateParamFileNameUrl']
        ? [
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: this.templateManageStore['templateParamFileNameUrl'],
            },
          ]
        : [];
      } else {
        return this.templateManageStore[this.url]
        ? this.templateManageStore[this.url].map((item:any, index:any) => ({
          uid: `-${index + 1}`,
          name: item.fileName,
          status: 'done',
          url: item.url,
        })):[]
      }
    }
  }

  @action
  setFileList(fileList: UploadFile[], file?: any): void {
    console.log(fileList, file, this.name);

    this._fileList = fileList;
    this.isEdited = true;

    if (fileList.length > 0) {
      // if(file){
      //   this.templateManageStore.temporaryUpload(this.name, file);
      // }else{
      //   fileList.map((item:any)=>{
      //     this.templateManageStore[this.name].push(item.name);
      //   })
      // }
      if (this.name !== "templateParamFileName") {
        this.templateManageStore[`${this.name}Obj`] = fileList.map(
          (item) => item.name
        );
        console.log(JSON.parse(JSON.stringify(this.templateManageStore['orderVoucherObjectNamesObj'])));
        
      }
      
    } else {
      if (this.name !== "templateParamFileName") {
        this.templateManageStore[`${this.name}Obj`] = [];
      }else{
        this.templateManageStore['templateParamFileName']=''
      }
      
    }
  }

  @action
  reset() {
    this._fileList = [];
    this.isEdited = false;
  }
}

export default UploadImgStore;
